import { createFocusTrap } from 'focus-trap'
import $ from 'jquery';

const dialogs = [...document.getElementsByClassName('js-dialog')]
const dialogOpenBtns = [...document.getElementsByClassName('js-dialog-open')]
const dialogCloseBtns = [...document.getElementsByClassName('js-dialog-close')]
const traps = {}

const closeDialog = (dialog) => {
  document.documentElement.classList.remove('dialog-open')
  dialog.classList.remove('is-open')
  traps[dialog.id].deactivate()
}

//init keyboards traps + close escape with escape key
for (let index = 0; index < dialogs.length; index++) {
  const dialog = dialogs[index];
  const id = dialog.id
  traps[id] = createFocusTrap(dialog, {
    clickOutsideDeactivates: true,
    escapeDeactivates: false,
    initialFocus: false
  })

  dialog.addEventListener('click', (e) => {
    if (!e.target.classList.contains('dialog')) return
    closeDialog(dialog);
  })

  dialog.addEventListener('keyup', (e) => {
    if (e.key !== 'Escape') return
    closeDialog(dialog);
  })
}

for (let index = 0; index < dialogOpenBtns.length; index++) {
  const dialogOpenBtn = dialogOpenBtns[index];
  dialogOpenBtn.addEventListener('click', () => {
    const id = `dialog-${dialogOpenBtn.dataset.dialogId}`
    const dialog = document.getElementById(id)
    if (!dialog) return

    dialog.classList.add('is-open')
    document.documentElement.classList.add('dialog-open')
    traps[id].activate()

    // Fix scroll issue with chrome
    const wrapper = dialog.querySelector('.dialog__wrapper');
    if (wrapper) {
      wrapper.scrollTo(0,0);
    }

    // Focus on search element
    const focusEl = dialog.querySelector('.js-dialog-focus');
    if (focusEl) {
      focusEl.focus()
    }

    const accordionTarget = dialogOpenBtn.dataset.dialogAccordion
    if (!accordionTarget) return

    const accordionTargetEl = document.querySelector(`a[href="#${accordionTarget}"]`)
    if (!accordionTargetEl) return

    const accordion = accordionTargetEl.closest('.accordion');
    if (!accordion) return

    $(accordion).foundation('down', $(accordionTargetEl.nextElementSibling));
  })
}

for (let index = 0; index < dialogCloseBtns.length; index++) {
  const dialogCloseBtn = dialogCloseBtns[index];
  dialogCloseBtn.addEventListener('click', () => {
    const dialog = dialogCloseBtn.closest('.js-dialog')
    if (!dialog) return
    closeDialog(dialog);
  })
}
